<template>
  <div>
	  <div class="link-warp">
	  	<div class="link-item active">域名订单</div>
	  </div>
    <div class="condition-section">
      <div class="con-row">
        <div style="margin-right: 10px;margin-left: -5px">订单状态：</div>
        <div
          :class="['item', { active: item.value === searchObj.tradeState }]"
          v-for="item in tradeStateList"
          :key="item.value"
          @click="onCheckTradeStateList(item.value)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">创建时间：</div>
          <DatePicker
            class="height45"
            v-model="searchObj.value"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom"
            placeholder="创建时间"
            style="width: 200px"
            @on-change="onTimeChange"
          ></DatePicker>
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">订单列表（{{ searchObj.total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="state" slot-scope="{ row }">
          <div>
            {{ row.state | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button
            v-if="row.state == 0"
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            @click="onPay(row)"
            >付款</Button
          >
          <Button
            v-if="row.state == 0"
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            @click="onCancel(row)"
            >取消</Button
          >
          <Button
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            @click="onDetail(row)"
            >详情</Button
          >
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { orderPageList, orderCancel } from "api/domain.js";
export default {
  name: "order",
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未支付";
          break;
        case 1:
          title = "已支付";
          break;
        case 2:
          title = "已取消";
          break;
        case 3:
          title = "已过期";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      searchObj: {
        tradeState: 0, // 支付状态 0：未支付 1：已支付 2：已取消 3：已过期
        startCreatedTime: "",
        endCreatedTime: "",
        value: "", // 创建时间
        page: 1,
        limit: 20,
        total: 0,
      },
      tradeStateList: [
        {
          value: 0,
          name: "未支付",
        },
        {
          value: 1,
          name: "已支付",
        },
        {
          value: 2,
          name: "已取消",
        },
        {
          value: 3,
          name: "已过期",
        },
      ],
      columns: [
        {
          title: "序号",
          align: "center",
          type: "index",
        },
        {
          title: "订单号",
          align: "center",
          key: "id",
        },
        {
          title: "产品名称",
          align: "center",
          key: "ymList",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "订单金额",
          align: "center",
          key: "total",
        },
        {
          title: "状态",
          align: "center",
          slot: "state",
        },
        {
          width: 250,
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created() {
    this.onPageChange(1);
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          status: this.searchObj.tradeState,
          start: this.searchObj.startCreatedTime,
          end: this.searchObj.endCreatedTime,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        this.tableLoading = true;
        const { code, data } = await orderPageList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 时间变化
    onTimeChange(val) {
      this.searchObj.startCreatedTime = val[0];
      this.searchObj.endCreatedTime = val[1];
    },
    // 取消订单
    async onCancel(val) {
      try {
        let params = {
          orderNo: val.id,
        };
        const { code, result } = await orderCancel(params);
        if (code === 200 && result) {
          this.$Message.success("操作成功!");
          this.onSearch()
        } else {
          this.$Message.warning("操作失败!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 切换状态
    onCheckTradeStateList(val) {
      this.searchObj.tradeState = val;
      this.onPageChange(1);
    },
    // 付款
    onPay(val) {
      this.$router.push({ path: "/shoppingCart", query: { orderNo: val.id } });
    },
    // 详情
    onDetail(val) {
      this.$router.push({ path: "/customer/order/detail", query: { id: val.id } });
    },
  },
};
</script>

<style lang="less" scoped>
	.link-warp {
		padding: 0 15px;
		margin-top: 20px;

		.link-item {
			display: inline-block;
			height: 40px;
			line-height: 40px;
			padding: 0 30px;
			font-size: 16px;
			font-weight: 600;
			color: #4f5867;
			position: relative;
			cursor: pointer;
			transition: all 0.3s;
		}

		.link-item.active {
			border: 1px solid #759de6;
			color: #3992e9;
			font-weight: bold;
			&::before {
			  width: 100%;
			  background-color: #3992e9;
			}
		}
	}
	/deep/.domain-table {
		.ivu-table-header th {
			background-color: #315491;
		}

		.ivu-table-header th,
		.ivu-table-body td {
			height: 60px;
		}

		.ivu-table-tip {
			td {
				line-height: 300px;
			}
		}
	}

	.title {
		font-size: 20px;
		color: #3992e9;
		font-weight: bold;
		background-color: #fff;
		padding: 0px 60px;
		line-height: 80px;
		height: 80px;
	}
.condition-section {
  margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
  .con-row {
    display: flex;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    .item {
      font-size: 14px;
      font-weight: 600;
      color: #434063;
      cursor: pointer;
      margin-right: 40px;
      background: #f5f9fe;
      border-radius: 54px;
      border: 1px solid #759de6;
      width: 100px;
      text-align: center;
      line-height: 40px;
    }
    .item.active {
      color: #FFF;
      background: #315491;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 15px;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
   height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
